/**
 * notistack의 enqueueSnackbar를 React 외부(static 클래스 등)에서 호출하기 위한 헬퍼
 */
let snackbarRef = null

export const setSnackbarRef = (ref) => {
    snackbarRef = ref
}

export const showSnackbar = (message, options = {}) => {
    if (snackbarRef) {
        return snackbarRef.enqueueSnackbar(message, options)
    }
    return null
}

export const closeSnackbar = (key) => {
    if (snackbarRef) {
        snackbarRef.closeSnackbar(key)
    }
}
